module.exports = __webpack_public_path__ + "15db20df149b7c6408f52fe2df8e5e85.jpg";